import angular from 'angular';
import { dateEquals } from './dateEquals';

// angular.equals + date equals
export function tnEquals(obj1: unknown, obj2: unknown): boolean {
    return angular.equals(obj1, obj2) || dateEquals(obj1, obj2);
}